import { Toast } from 'antd-mobile';
import { topGameInfo, topGameList } from '@/services/activity';

export default {
  namespace: 'topGame',
  state: {
    endTime: 0,
    musicUrl: '',
    title: '',
    titleUrl: '',
    rules: '',
    ranks: [],
    selfInfo: {},
    rewards: [],
    lastId: '',
    status: 0,
    titleUrl: '',
    pageBackgroundColor: '#400F49',
    timeBorderColor: '#FFED8E',
    timeBackgroundColor: 'rgba(86, 0, 0, 0.4)',
    countdownColor: '#F0DD2C',
    meBackgroundImg: 'https://www.cdnmole.com/online/cms/image/d9c7f1f27a64b51e3475d8d5f1fdcfd9.png',
    timeNumColor: '#F0DD2C',
    timeUnitColor: '#fff',
    coinColor: '#F0DD2C',
    nameAndRankColor: '#fff',
    top3BackgroundImg: 'https://www.cdnmole.com/online/cms/image/d765f0ed87c97248a961fbcbb1d14dad.png',
    childPageUrl: 'https://www.cdnmole.com/online/cms/image/35c033edaa50947c7a461a2a16efc18b.png',
    childBgColor: '#28082d',
    rewardsUrl: '',
    buttonBackgroundImg: '',
    buttonTextColor: '',
    buttonUrl: '',
    rewardTitleBackgroundImg: '',
    rewardTitleTextColor: '',
    rewardTopItemBackgroundImg: '',
    rewardTopItemTextColor: '',
    rewardTagBackgroundImg: '',
    rewardTagTextColor: '',
    coinsRewards: [],
  },
  reducers: {
    updateInfo(state, { payload }) {
      return {
        ...state,
        endTime: payload.endTime || 0,
        musicUrl: payload.musicUrl,
        title: payload.title || '',
        titleUrl: payload.titleUrl,
        rules: payload.rules,
        childPageUrl: payload.childPageUrl || '',
        gifts: payload.gifts || [],
        rewards: payload.totalRewards || [],
        childBgColor: payload.childBgColor || '#000',
        status: payload.status || 0,
        pageBackgroundColor: payload.pageBackgroundColor || '',
        timeBorderColor: payload.timeBorderColor || '',
        timeBackgroundColor: payload.timeBackgroundColor || '',
        countdownColor: payload.countdownColor || '',
        meBackgroundImg: payload.meBackgroundImg || '',
        timeNumColor: payload.timeNumColor || '',
        timeUnitColor: payload.timeUnitColor || '',
        coinColor: payload.coinColor || '',
        nameAndRankColor: payload.nameAndRankColor || '',
        top3BackgroundImg: payload.top3BackgroundImg || '',
        rewardsUrl: payload.rewardsUrl || '',
        // 2024.06 增加金币奖励类型
        buttonBackgroundImg: payload.buttonBackgroundImg || '',
        buttonTextColor: payload.buttonTextColor || '',
        buttonUrl: payload.buttonUrl || '',
        rewardTitleBackgroundImg: payload.rewardTitleBackgroundImg || '',
        rewardTitleTextColor: payload.rewardTitleTextColor || '',
        rewardTopItemBackgroundImg: payload.rewardTopItemBackgroundImg || '',
        rewardTopItemTextColor: payload.rewardTopItemTextColor || '',
        rewardTagBackgroundImg: payload.rewardTagBackgroundImg || '',
        rewardTagTextColor: payload.rewardTagTextColor || '',
        coinsRewards: payload.coinsRewards || [],
      };
    },
    updateList(state, { payload }) {
      let list = payload.force ? [] : [...state.ranks];
      let selfInfo = {};
      let lastId = '';
      if (payload.ranks && payload.ranks.length) {
        list = [...list, ...payload.ranks];
        lastId = payload.ranks[payload.ranks.length - 1].userId;
      }
      if (payload.selfInfo && payload.selfInfo.userId) {
        selfInfo = payload.selfInfo;
      }
      return {
        ...state,
        selfInfo: selfInfo,
        ranks: list,
        lastId: lastId,
      };
    },
  },
  effects: {
    *getInfo({ payload }, { call, put }) {
      const { error, data } = yield call(topGameInfo, payload);
      if (error || !data) {
        yield put({
          type: 'updateInfo',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      yield put({
        type: 'updateInfo',
        payload: data,
      });
      return true;
    },
    *getList({ payload }, { call, put, select }) {
      const { lastId } = yield select(state => state.topGame);
      const { error, data } = yield call(topGameList, { ...payload, lastId: payload.force ? '' : lastId, force: undefined });
      if (error || !data) {
        yield put({
          type: 'updateList',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      yield put({
        type: 'updateList',
        payload: { ...data, force: payload.force },
      });
      return true;
    },
  },
};
